import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents';
import { convertDate24Hrs } from 'helpers/hooks/formatDate';
import { toProperCase } from 'helpers/hooks/stringNumberFunction/stringConverter';
import React from 'react';
import './orderItemReceipt.scss';

interface orderItemReceiptProps {
	outletName: string;
	data: any;
	printerName?: any;
	orderItemData?: any;
	voidItemData?: any;
	voidQuantity?: any;
	reasonCode?: any;
	remark?: any;
	hidden?: boolean;
	mode?: string;
}

export const OrderItemReceipt = (props: orderItemReceiptProps) => {
	const {
		outletName,
		data,
		printerName,
		orderItemData,
		voidItemData,
		voidQuantity,
		reasonCode,
		remark,
		hidden,
		mode,
	} = props;

	const loggedInUser = JSON.parse(localStorage.getItem('loggedInUser'));

	return (
		<div
			id={printerName}
			style={
				hidden
					? {
							zIndex: -40,
							top: 0,
							left: 0,
							position: 'fixed',
							width: '300px',
							fontSize: '18px',
					  }
					: {
							zIndex: 40,
							position: 'relative',
					  }
			}
		>
			<CardContents>
				{mode !== 'void' ? (
					<div className="content-wrap full" style={{ marginRight: '5px' }}>
						<div className={'mdTitle-bold'} style={{ paddingBottom: '5px' }}>
							Outlet: &nbsp;
							<span className="lgDesc">{outletName}</span>
						</div>

						<div className={'mdTitle-bold'} style={{ paddingBottom: '5px' }}>
							Order No: &nbsp;
							<span className="lgDesc">{data?.docNo}</span>
							<div className="mdTitle-bold right-info">
								Cover: &nbsp;
								<span className="lgDesc">{data?.pax}</span>
							</div>
						</div>

						<div className={'mdTitle-bold'} style={{ paddingBottom: '5px' }}>
							{/* {'Table Location'} */}
							{/* <div className="mdTitle-bold right-info"> */}
							<div className="mdTitle-bold right-info">
								Table: &nbsp;
								<span className="lgDesc">
									{data?.table?.prefix + data?.table?.tableNumber}
								</span>
							</div>
						</div>

						<div className={'mdTitle-bold'} style={{ paddingBottom: '5px' }}>
							{Array.from(
								new Set(
									orderItemData?.map(x => x?.menuItem?.kitchenPrinter?.name),
								),
							)}
						</div>

						<div className={'mdTitle-bold'} style={{ paddingBottom: '5px' }}>
							{loggedInUser?.name}
							<div className="mdTitle-bold right-info">
								<span className="mdDesc">
									{convertDate24Hrs(data?.createdTs)}
								</span>
							</div>
						</div>
						<hr className="receipt-divider" />

						{orderItemData?.map((v, index) => (
							<div
								className="dialog-dynamic-content"
								style={{ marginBottom: '10px' }}
							>
								<div className="session">
									<div className="flex session">
										<div
											className=" flex-space desc"
											style={{ alignSelf: 'center', fontSize: '16px' }}
										>
											{v?.menuItem?.name}
										</div>
										<div className="desc" style={{ fontSize: '16px' }}>
											{v?.quantity}
										</div>
									</div>
									{v?.orderItemOption?.length
										? v?.orderItemOption?.map(x => (
												<>
													{x?.orderItemOptionItem?.map(x => (
														<div className="flex session">
															<div
																className="desc flex-space"
																style={{
																	color: '#757575',
																	fontWeight: 500,
																	alignSelf: 'center',
																	fontSize: '14px',
																}}
															>
																{x?.optionItem?.name}
															</div>
														</div>
													))}
												</>
										  ))
										: v?.orderItemSetMenuOption?.map(x => (
												<>
													{x?.orderItemSetMenuOptionItem?.map(e => (
														<div
															className="desc"
															style={{
																color: '#757575',
																fontWeight: 500,
																paddingBottom: '2px',
																fontSize: '14px',
															}}
														>
															{e?.setMenuOptionItem?.menuItem?.name}
														</div>
													))}
												</>
										  ))}
								</div>
							</div>
						))}

						<hr className="receipt-divider" style={{ marginTop: '10px' }} />
					</div>
				) : (
					<div className="content-wrap full" style={{ marginRight: '5px' }}>
						<div
							className={'mdTitle-bold'}
							style={{
								marginBlock: '15px',
								textAlign: 'center',
								color: '#000000',
							}}
						>
							Void Item
						</div>
						<div className={'mdTitle-bold'} style={{ paddingBottom: '5px' }}>
							Outlet: &nbsp;
							<span className="lgDesc">{outletName}</span>
						</div>

						<div className={'mdTitle-bold'} style={{ paddingBottom: '5px' }}>
							Order No: &nbsp;
							<span className="lgDesc">{data?.docNo}</span>
							<div className="mdTitle-bold right-info">
								Cover: &nbsp;
								<span className="lgDesc">{data?.pax}</span>
							</div>
						</div>

						<div className={'mdTitle-bold'} style={{ paddingBottom: '5px' }}>
							<div className="mdTitle-bold">
								Table: &nbsp;
								<span className="lgDesc">
									{data?.table?.prefix + data?.table?.tableNumber}
								</span>
							</div>
						</div>

						{voidItemData?.menuItem?.kitchenPrinter !== null && (
							<div className={'mdTitle-bold'} style={{ paddingBottom: '5px' }}>
								Printer: &nbsp;
								{voidItemData?.menuItem?.kitchenPrinter?.name}
							</div>
						)}

						<div className={'mdTitle-bold'} style={{ paddingBottom: '5px' }}>
							{loggedInUser?.name}
							<div className="mdTitle-bold right-info">
								<span className="mdDesc">
									{convertDate24Hrs(new Date().toISOString())}
									{/* {new Date().toISOString()} */}
								</span>
							</div>
						</div>
						<hr className="receipt-divider" />

						<div
							className="dialog-dynamic-content"
							style={{ marginBottom: '5px', color: '#000000' }}
						>
							<div className="session">
								<div className="flex session">
									<div
										className=" flex-space desc"
										style={{ alignSelf: 'center', fontSize: '16px' }}
									>
										{voidItemData?.menuItem?.name}
									</div>
									<div className="desc" style={{ fontSize: '16px' }}>
										{voidQuantity}
									</div>
								</div>
								{voidItemData?.orderItemOption?.length
									? voidItemData?.orderItemOption?.map(x => (
											<>
												{x?.orderItemOptionItem?.map(x => (
													<div className="flex session">
														<div
															className="desc flex-space"
															style={{
																color: '#000000',
																fontWeight: 500,
																alignSelf: 'center',
																fontSize: '14px',
															}}
														>
															{x?.optionItem?.name}
														</div>
													</div>
												))}
											</>
									  ))
									: voidItemData?.orderItemSetMenuOption?.map(x => (
											<>
												{x?.orderItemSetMenuOptionItem?.map(e => (
													<div
														className="desc"
														style={{
															color: '#000000',
															fontWeight: 500,
															paddingBottom: '2px',
															fontSize: '14px',
														}}
													>
														{e?.setMenuOptionItem?.menuItem?.name}
													</div>
												))}
											</>
									  ))}
							</div>
						</div>
						<div className="session" style={{ color: '#000000' }}>
							<div className="flex session">
								<div
									className="flex-space desc"
									style={{ alignSelf: 'center' }}
								>
									Reason :
									<span style={{ fontSize: '18px' }}>
										{reasonCode?.toUpperCase()}
									</span>
								</div>
							</div>
						</div>
						{remark && (
							<div
								className="session"
								style={{ color: '#000000', marginTop: '2px' }}
							>
								<div className="flex session">
									<div
										className=" flex-space desc"
										style={{ alignSelf: 'center' }}
									>
										<span>{toProperCase(remark)}</span>
									</div>
								</div>
							</div>
						)}

						<hr className="receipt-divider" style={{ marginTop: '10px' }} />
					</div>
				)}
			</CardContents>
		</div>
	);
};
